import { FC } from "react";
import { NavLink, NavLinkProps } from "react-router-dom";
import { Flex, ButtonProps, Box } from "@chakra-ui/react";
import { Constants } from "../../utils";

export type NavItemProps = {
    show?: boolean;
    text: string;
    colorScheme: string;
    collapsed?: boolean;
} & Pick<ButtonProps, "leftIcon"> &
    NavLinkProps;

export const NavItem: FC<NavItemProps> = props => {
    const { show, text, colorScheme, collapsed, ...rest } = props,
        { leftIcon, ...navItemProps } = rest;

    return show ? (
        <NavLink {...navItemProps} style={{ width: "100%" }}>
            {({ isActive }) => (
                <Flex
                    alignItems="center"
                    gap=".6rem"
                    position="relative"
                    minHeight="2.5rem"
                    sx={{
                        paddingX: collapsed ? 0 : isActive ? "calc(1.25rem - 3px)" : "1.25rem",
                        paddingY: ".5rem",
                        borderRadius: 0,
                        justifyContent: collapsed ? "center" : "flex-start",
                        color: "white",
                        width: "100%",
                        fontSize: ".95rem",
                        transition: "background 0.2s",
                        _hover: {
                            backgroundColor: isActive ? `${colorScheme}.400` : "whiteAlpha.400",
                            cursor: isActive ? "default" : "pointer",
                            transitionDuration: "0.2s",
                        },
                        ...(isActive
                            ? {
                                  bg: `${colorScheme}.400`,
                                  _after: {
                                      content: "''",
                                      position: "absolute",
                                      bg: `${colorScheme}.400`,
                                      top: 0,
                                      right: "-10px",
                                      bottom: 0,
                                      width: "10.3px",
                                      clipPath: "polygon(0% 0%, 100% 50%, 0% 100%)",
                                  },
                              }
                            : {}),
                    }}
                >
                    {collapsed ? (
                        <Box width="100%" display="flex" justifyContent="center" alignItems="center" title={text}>
                            {leftIcon}
                        </Box>
                    ) : (
                        leftIcon
                    )}
                    {collapsed ? Constants.emptyString : text}
                </Flex>
            )}
        </NavLink>
    ) : null;
};
